// extracted by mini-css-extract-plugin
export default {"tableContent":"WeightHistoryTable_tableContent__QAG77"};